<template>
  <!-- 用户管理-赠送coins -->
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="添加coins"
      width="400px"
      @close="closeDialog"
    >
      <el-form
        :model="dataForm"
        ref="dataForm"
        label-width="100px"
        size="small"
        :rules="replyRules"
      >
        <el-form-item prop="receive_amount" label="金额">
          <el-input placeholder="请输入金额" v-model="dataForm.receive_amount">
          </el-input>
        </el-form-item>
        <el-form-item prop="time2" label="失效时间">
          <!-- <el-input
            placeholder="请输入时间"
            v-model="dataForm.overdue"
            style="width: 100px; margin-right: 5px"
          >
          </el-input>
          <el-select
            v-model="dataForm.overdue_unit"
            placeholder="请选择单位"
            style="width: 120px"
          >
            <el-option :value="1" label="小时"></el-option>
            <el-option :value="2" label="日"></el-option>
          </el-select> -->
          <el-date-picker
            v-model="dataForm.failure_time"
            type="datetime"
            placeholder="选择日期时间"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button @click="closeDialog">取消</el-button>
          <el-button type="primary" @click="submit" :loading="buttonLoading"
            >确定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import http, { server, api, delApiData, getApiData, postApiData, patchApiData } from '@/http'

export default {
  props: {
    visible: {//展示标志
      type: Boolean,
      default: false
    },
    value: {//数据
      type: Object,
      default: undefined
    },
    type: {//类型
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      loading: false,//加载动画
      buttonLoading: false,//按钮加载动画
      lock:false,//加锁
      imgType: 'prize',//上传图片的种类 奖品
      dataForm: {
        user_id: undefined,
        receive_amount: undefined,
        failure_time: undefined,
      },
      replyRules: {//回复弹窗规则验证
      }
    }
  },
  computed: {
    ...mapState({
    }),
    dialogVisible: {
      get() {
        return this.visible
      },
      set() {
      }
    },
    fromInfo: {
      get() {
        return this.value
      },
      set() {
      }
    },
  },
  watch: {
    dialogVisible(val) {
      if (val && this.fromInfo) {
        this.dataForm.user_id = this.fromInfo.id
        this.dataForm.receive_amount = undefined
        this.dataForm.failure_time = undefined
      } else {
        this.dataForm = {
          user_id: undefined,
          receive_amount: undefined,
          failure_time: undefined,
        }
      }
    },
  },
  created() {
  },
  methods: {
    submit(id) {
      //保存任务
      //表单验证后发起请求
      this.buttonLoading = true
      let params = this.dataForm
      if(this.lock){
        return
      }
      this.lock=true
      postApiData('giving_coin', params).then(res => {
        if (res.code) {
          this.$message.success(res.message)
          this.$emit('refresh')
          this.closeDialog()
        } else {
          this.$message.error(res.message)
        }
      }).finally(() => {
        this.lock=false
        this.buttonLoading = false
      })
    },
    closeDialog() {
      //关闭弹窗
      this.$emit("close")
    }
  }

}
</script>
<style lang="less" scoped>
</style>